module.exports = __webpack_public_path__ + "static/media/Logo.61aa2bd0.svg";